var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoHeader(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 159,
    height: 32,
    viewBox: "0 0 159 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.779785,
    width: 3.68834,
    height: 31.1926,
    fill: "#DD4242"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M153.875 16.3635C153.875 12.7523 150.958 9.82289 147.363 9.82289C143.767 9.82289 140.85 12.7523 140.85 16.3635C140.85 19.9747 143.767 22.9041 147.363 22.9041C150.962 22.9041 153.875 19.9747 153.875 16.3635ZM158.072 16.3635C158.072 22.3042 153.278 27.1191 147.363 27.1191C141.447 27.1191 136.653 22.3042 136.653 16.3635C136.653 10.4228 141.447 5.60791 147.363 5.60791C153.278 5.60791 158.072 10.4228 158.072 16.3635Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M121.59 5.60791C119.099 5.60791 116.807 6.46447 114.987 7.89725V5.60791H110.878V16.3577V16.5485V27.123H115.072V16.3577C115.072 12.7485 117.99 9.8206 121.586 9.8206C125.183 9.8206 128.104 12.7446 128.104 16.3577V27.1191H132.302V16.3577C132.298 10.4202 127.503 5.60791 121.59 5.60791Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M106.524 5.48975L98.2356 27.1192H92.9803L84.6338 5.48975H89.1201L95.6041 22.2936L102.042 5.48975H106.524Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M80.2793 5.60791H76.2778V27.0009H80.2793V5.60791Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M71.8054 9.89224H65.5415V18.5114C65.5415 20.9486 67.4668 22.9239 69.8423 22.9239H71.8016V27.119H69.8423C65.2086 27.119 61.4487 23.2654 61.4487 18.5076V0.170898H65.5377V5.69712H71.8016V9.89224H71.8054Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M39.8721 16.2986C39.8721 19.888 42.7896 22.7998 46.3861 22.7998C49.9825 22.7998 52.9 19.888 52.9 16.2986C52.9 12.7092 49.9825 9.79746 46.3861 9.79746C42.7857 9.79359 39.8721 12.7054 39.8721 16.2986ZM57.0939 16.2986V27.0009H52.9V24.7823C51.096 26.1646 48.838 26.9854 46.3861 26.9854C40.4696 26.9854 35.6743 22.1996 35.6743 16.2986C35.6743 10.3938 40.4696 5.60791 46.3861 5.60791C52.2987 5.60791 57.0939 10.3938 57.0939 16.2986Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6121 5.60791C18.1214 5.60791 15.8285 6.46447 14.0089 7.89725V5.60791H9.90039V16.3577V16.5485V27.123H14.0943V16.3577C14.0943 12.7485 17.0118 9.8206 20.6082 9.8206C24.2047 9.8206 27.1261 12.7446 27.1261 16.3577V27.1191H31.3239V16.3577C31.32 10.4202 26.5247 5.60791 20.6121 5.60791Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoHeader);
export default __webpack_public_path__ + "static/media/logo_header.48d1114a.svg";
export { ForwardRef as ReactComponent };